class Footer {
  constructor() {
    this.menuShow();
  }
  menuShow(){
    $('.footer__nav-item-title').click(function() {
      $(this).find('.plus-button').toggleClass('plus-button--active');
      $(this).parent().find('.footer__submenu').toggleClass('visible');
    });
	}
}

var footer = new Footer()
